import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { modalStore } from 'apps/modals/app';
import { Button, Paragraph, Heading, SvgIcon } from 'components';
import { ArrowRight } from 'icons';
import type { RFQState } from 'apps/rfq/rfqStates';

const Wrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center',
});

const StatusChangeWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: '20px',
  backgroundColor: '#f7f7f7',
  padding: '20px',
  alignSelf: 'stretch',
  justifyContent: 'center',
});

const ButtonsWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  gap: '40px',
  marginTop: theme.spacing.large,
}));

type ModalProps = {
  fadeIn: () => {};
};

type StatusSwitchConfirmationModalProps = ModalProps & {
  from: RFQState;
  to: RFQState;
  type: string;
  StatusDisplayComponent: any;
};

const StatusSwitchConfirmationModal = (
  props: StatusSwitchConfirmationModalProps,
) => {
  const { from, to, fadeIn, StatusDisplayComponent, type } = props;
  // this replaces 'extends Modal' if this was written as a class component.
  useEffect(() => {
    setTimeout(() => {
      fadeIn();
    }, 1);
  }, []);

  return (
    <Wrapper>
      <div style={{ alignSelf: 'flex-start' }}>
        <Heading size='large' level='6'>
          Confirm Status Change
        </Heading>
      </div>
      <div style={{ alignSelf: 'flex-start' }}>
        <Paragraph size='default' margin='medium 0'>
          {"Are you sure you want to change this RFQ's status?"}
        </Paragraph>
      </div>
      <StatusChangeWrapper>
        <StatusDisplayComponent status={from} noLabel type={type} />
        <SvgIcon icon={<ArrowRight />} color='primary' />
        <StatusDisplayComponent status={to} noLabel type={type} />
      </StatusChangeWrapper>
      <ButtonsWrapper>
        <Button
          onClick={() => {
            modalStore.Close(true);
          }}
          text='Change'
          variant='primary'
          icon='check'
          outline
          iconPosition='right'
        />
        <Button
          onClick={() => {
            modalStore.Close(false);
          }}
          text='Cancel'
          variant='secondary'
          icon='close'
          iconPosition='right'
        />
      </ButtonsWrapper>
    </Wrapper>
  );
};

export default observer(StatusSwitchConfirmationModal);
